export function cleanLabel(label = "") {
    return label.replace("Ready:", "").replace("Live:", "").replace("Publish:", "").trim()
}

function readable(value) {
    return !!value && !/^_[A-Za-z0-9_-]{6,}$/.test(value)
}

export function labelFor(asset) {
    const candidates = [asset.description, asset.type, asset.category, asset.tag, asset.name].filter(readable)
    return candidates[0] || asset.tag || asset.name || "Asset"
}
